<template>
  <v-container
    class="loading-wrapper"
    fill-height
  >
    <v-layout justify-center>
      <v-progress-circular
        v-bind:size="size"
        v-bind:width="width"
        :color="color"
        style="z-index: 1;"
        indeterminate
      ></v-progress-circular>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'purple',
    },
    size: {
      type: Number,
      default: 90,
    },
    width: {
      type: Number,
      default: 7,
    },
  },
};
</script>

<style scoped>
.loading-wrapper {
  min-height: 50vh;
}
</style>
